import { Component, OnInit } from '@angular/core';
import { Info } from '../../../modals/info.model';
import { InfoService } from '../services/info.service';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss']
})
export class FooterComponent implements OnInit {

  infos:Info|null=null;
  constructor(private infoService:InfoService) { }

  ngOnInit() {
    this.infoService.getInfo().subscribe((info:Info)=>{
    this.infos=info;
  })
  }

}
